import { USER_ADDITION_SUFFIX } from '@/common/constants/rtc';
import { reportData } from '_api/report';

const ScreenShare = {
  state: () => ({
    screen_share_check_info: {}, // 是否为升级版屏幕共享
    screen_share_user_list: [], // 正在进行屏幕共享的用户列表
    screen_sharing_info: {}, // 正在展示屏幕共享的用户信息
    my_screen_sharing: false, // 当前用户是否正在共享屏幕
    screen_sharing_voice_level: 100, // 当前用户开始屏幕共享的上传声音大小
    is_user_stop_receive_screen_share: false, // 当前用户是否手动关闭了屏幕共享
    // 是否允许展示screenShareButton组件
    // screen_share_user_list从空到有的过程由于需要chat接口异步校验是否允许观看
    // 会导致IM.vue中ScreenShareButton和ScreenShare组件闪烁
    // 此处开关确保screenShareButton在chat接口异步校验完成后展示，防止闪烁问题
    is_allow_show_screen_share_button: false, 

    is_show_screen_share_menu: false, // 是否显示屏幕共享的工具菜单
    is_screen_share_fullscreen: false, // 屏幕共享是否全屏
    is_screen_share_browser_fullscreen: false, //  屏幕共享是否窗口全屏


    screen_share_resizing: false, // 是否正在调整屏幕共享窗口大小
    screen_share_cpt_height: 0, // 屏幕共享组件高度
    screen_share_cpt_width: 0, // 屏幕共享组件宽度

    is_focusing_mini_input: false, // 是否正在聚焦mini输入框
  }),
  getters: {
    screen_sharing_info: (state, rootState) => {
      if (state.screen_sharing_info.user_id) {
        let user = rootState.cur_channel_data.members?.find(u => state.screen_sharing_info.user_id == u.user_id) || {}
        return {
          ...state.screen_sharing_info,
          ...user,
        }
      } else {
        return state.screen_sharing_info
      }
    },
    is_show_screen_sharing: (state) => (channel_id) => {
      return Boolean(channel_id && state.screen_sharing_info.channel_id === channel_id && state.screen_sharing_info.user_id)
    },
    screen_share_check_info: (state) => state.screen_share_check_info,
    // 通过rtc回调确定成功推流屏幕共享的用户列表
    screen_share_user_list: (state, rootState) => {
      return state.screen_share_user_list.map(v => {
        return {
          ...rootState.cur_channel_data.members?.find(u => v.user_id == u.user_id) || {},
          ...v,
        }
      })
    },
    // 频道内状态是正在屏幕共享的用户列表，有可能状态时在屏幕共享但是推流已经断了，比如推流用户电脑休眠
    screen_share_state_user_list: (state, rootState) => {
      let users = []
      rootState.cur_channel_data.members.forEach(user => {
        if (user.screen_share_info) {
          let screen_share_user = state.screen_share_user_list.find(v => v.user_id == user.user_id) || {}
          users.push({
            ...screen_share_user,
            ...user
          })
        }
      })
      return users
    },
    my_screen_sharing: (state) => {
      return state.my_screen_sharing
    },
    screen_sharing_voice_level: (state) => state.screen_sharing_voice_level,
    is_user_stop_receive_screen_share: (state) => state.is_user_stop_receive_screen_share,
    is_allow_show_screen_share_button: (state) => state.is_allow_show_screen_share_button,

    /**
     *  1.27.0 屏幕共享迁移至Room，跨组件使用Vuex统一管理状态
     */
    is_show_screen_share_menu: (state) => state.is_show_screen_share_menu,
    is_screen_share_fullscreen: (state) => state.is_screen_share_fullscreen,
    is_screen_share_browser_fullscreen: (state) => state.is_screen_share_browser_fullscreen,
    cur_channel_has_screen_share: (state, rootState) => {
      // 针对频道内主播只有自己的情况做一个兼容，确保在start好之后再刷新
      if(rootState.cur_channel_data?.members && rootState.cur_channel_data?.members.length) {
        const sharingList = rootState.cur_channel_data.members.filter(u => u.screen_share_info)
        const isOnlyMe = sharingList.length === 1 && String(sharingList[0].user_id) === rootState.user_info.user_id
        if(isOnlyMe){
          return !!state.my_screen_sharing
        }else{
          return sharingList.length > 0
        }
      } else {
        return false
      }
    },
    screen_share_cpt_height: (state) => state.screen_share_cpt_height,
    screen_share_resizing: (state) => state.screen_share_resizing,
    screen_share_cpt_width: (state) => state.screen_share_cpt_width,
    is_focusing_mini_input: (state) => state.is_focusing_mini_input,
  },
  mutations: {
    SET_SCREEN_SHARE_CHECK_INFO(state, val) {
      state.screen_share_check_info = val
    },
    SET_SCREEN_SHARING_INFO(state, val) {
      const { _user_id, ...originValue } = val
      if (val.user_id) {
        state.is_user_stop_receive_screen_share = false // 只要用户展示了屏幕共享, 就将 手动关闭了屏幕共享 的值设为false
      }
      state.screen_sharing_info = originValue
      window.electronAPI?.setUserAudioState({
        is_receive_screen_share: Boolean(val.user_id && val.user_id != val._user_id)
      })
    },
    SET_SCREEN_SHARE_USER_LIST(state, val) {
      if (Array.isArray(val)) {
        state.screen_share_user_list = val
      } else if (val.type === 'add') {
        if (!state.screen_share_user_list.find(v => v.user_id == val.data.user_id)) {
          if (val.data.user_id == val._user_id) {
            val.data.is_me = true
          }
          state.screen_share_user_list.push(val.data)
        }
      } else if (val.type === 'remove') {
        state.screen_share_user_list = state.screen_share_user_list.filter(v => v.user_id != val.data.user_id)
      } else {
        state.screen_share_user_list = val
      }
    },
    SET_SCREEN_SHARING_VOICE_LEVEL(state, val) {
      state.screen_sharing_voice_level = val
    },
    // my_screen_sharing
    SET_MY_SCREEN_SHARING (state, val) {
      state.my_screen_sharing = val
      window.electronAPI?.setUserAudioState({
        my_screen_sharing: val
      })
    },
    SET_IS_USER_STOP_RECEIVE_SCREEN_SHARE(state, val) {
      state.is_user_stop_receive_screen_share = val
    },
    SET_IS_ALLOW_SHOW_SCREEN_SHARE_BUTTON(state, val) {
      state.is_allow_show_screen_share_button = val
    },
    SET_IS_SHOW_SCREEN_SHARE_MENU(state, val){
      state.is_show_screen_share_menu = val
    },
    SET_IS_SCREEN_SHARE_FULLSCREEN(state, val){
      state.is_screen_share_fullscreen = val
    },
    SET_IS_SCREEN_SHARE_BROWSER_FULLSCREEN(state, val){
      state.is_screen_share_browser_fullscreen = val
    },
    SET_SCREEN_SHARE_CPT_HEIGHT(state, val){
      state.screen_share_cpt_height = val
    },
    SET_SCREEN_SHARE_RESIZING(state, val){
      state.screen_share_resizing = val
    },
    SET_SCREEN_SHARE_CPT_WIDTH(state, val){
      state.screen_share_cpt_width = val
    },
    SET_IS_FOCUSING_MINI_INPUT(state, val){
      state.is_focusing_mini_input = val
    },
  },
  actions: {
    SET_SCREEN_SHARE_MEMBER_VOICE_LEVEL: ({ dispatch }, {level, user_id}) => {
      user_id = user_id + USER_ADDITION_SUFFIX
      dispatch('SET_SINGLE_MEMBER_VOICE_LEVEL', {level, user_id})
    },
    SET_SCREEN_SHARE_USER_LIST: ({ commit, rootState }, value) => {
      value._user_id = rootState.user.user_info.user_id
      commit('SET_SCREEN_SHARE_USER_LIST', value)
    },
    SET_SCREEN_SHARING_INFO: ({ commit, rootState, getters }, value) => {
      const myUserId = rootState.user.user_info.user_id
      value._user_id = myUserId
      const nowTime = Date.now()
      value._ts = nowTime
      const channelAvLine = rootState.room.cur_channel_data.api_type
      value._av_line = channelAvLine

      const currentScreenSharingInfo = JSON.parse(JSON.stringify(getters.screen_sharing_info))

      // 屏幕共享结束，无论自己还是其他人的
      const isStopShow = !value.user_id

      // 切换用户
      const isSwitchUser = currentScreenSharingInfo.user_id && currentScreenSharingInfo.user_id !== value.user_id

      // 需要上报时长
      const isNeedReport = isStopShow || isSwitchUser

      // REPORT 结束或者切换时上报屏幕共享
      if(isNeedReport) {
        const diff = nowTime - currentScreenSharingInfo._ts
        const isAudience = currentScreenSharingInfo.user_id !== myUserId

        const addition = {
          diff,
          role: isAudience ? 'audience' : 'emcee',
          av_line: currentScreenSharingInfo._av_line,
          resolution: currentScreenSharingInfo.screen_share_info?.resolution || 480,
          emcee_user: isAudience ? currentScreenSharingInfo.user_id : undefined,
        }

        reportData('screen_share_duration', addition)
      }
      commit('SET_SCREEN_SHARING_INFO', value)
    },
  }
}
export default ScreenShare